import React from "react";
import { Input } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import FieldFrame from "./FieldFrame";

const DateField = ({ field, control, disabled, error, required }) => (
  <Controller
    control={control}
    name={field.code}
    render={({ field: input }) => (
      <FieldFrame field={field} error={error} isRequired={required}>
        <Input {...input} value={input.value ?? ""} type="date" isDisabled={disabled} />
      </FieldFrame>
    )}
  />
);

export default DateField;
